import type { SkillTemplate } from './issue-log-xref.js';
import { testCasesRenderCurrent } from './test-cases-current.js';
import { testCasesRenderV2_3_0 } from './test-cases-v2-3-0.js';

export const testCasesTemplate: SkillTemplate = {
  name: 'test-cases',
  description:
    'Author high-quality test cases as `.cofactor.md` specs that compile straight into Cofactor workflows. Invoke when the user asks to write test cases, draft a test plan, plan QA scenarios, decide what to test, or convert a PRD/ticket/design into tests.',
  version: '2.4.0',
  render: testCasesRenderCurrent,
  previousVersions: {
    '2.3.0': testCasesRenderV2_3_0,
  },
};
